import React from 'react';
import {
  Box,
  Button,
  Card,
  Skeleton,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ConversationListCard from '@app/components/presentational/MessagingResponsive/ConversationListCard';

// Mock data till API integration is pending.
const conversations = [
  {
    messages: [],
    id: 'eaade211-9971-4ea1-8efc-06c051b78373',
    createdAt: '2026-02-13T10:20:20.082Z',
    participants: {
      '624fb8b6-3746-4eee-b0e2-03a2cb18ecf6': {
        readUpTo: '2026-02-13T10:24:39.382Z',
        joinedAt: '2026-02-13T10:20:20.101Z',
      },
      'fdad06c6-e257-47e7-8cb2-3c7e02751e76': {
        joinedAt: '2026-02-13T10:20:20.101Z',
      },
      '212a8cbd-d076-4352-82f2-d74dcf15302e': {
        joinedAt: '2026-02-13T10:20:20.100Z',
      },
      'd02ebeda-40fd-4f64-9e5b-9207b86106c8': {
        joinedAt: '2026-02-13T10:20:20.101Z',
      },
    },
    isGroup: true,
    educatorOnly: false,
    spaceId: null,
    boundToSpaceGroup: '698efa580ee1074473390701',
    latestMessage: {
      id: 'b9ba5fec-2af1-44ad-8543-220a3b24ef4c',
      writer: '624fb8b6-3746-4eee-b0e2-03a2cb18ecf6',
      createdAt: '2026-02-13T10:21:01.066Z',
      preview: 'hello!',
    },
    title: 'Group 1 - Discussion 1 - Small groups',
  },
];

const MessageCardSkeleton = () => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      gap={2}
      p={2}
      borderRadius={3}
      bgcolor={palette.action.hover}
    >
      <Skeleton kind="circular" width={40} height={40} />

      <Box flex={1}>
        <Skeleton kind="text" width="45%" height={30} />

        <Skeleton kind="text" width="30%" height={24} />

        <Skeleton kind="text" width="100%" height={34} />
      </Box>

      <Skeleton kind="circular" width={10} height={10} sx={{ mt: 1 }} />
    </Box>
  );
};

const MessagesWidget = () => {
  const { palette } = useTheme();
  const isLoading = false;

  return (
    <Card
      sx={{
        borderRadius: '0.75rem',
        padding: '1rem',
        boxShadow: 'none',
        border: `1px solid ${palette.divider}`,
        bgcolor: palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '600px',
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
        mt={-0.5}
      >
        <Box display="flex" alignItems="center" gap="10px">
          <Typography variant="subtitle1" fontWeight="medium" color="primary">
            Messages
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap={0} flex={1}>
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Box key={index} mt={1}>
              <MessageCardSkeleton />
            </Box>
          ))
        ) : conversations.length > 0 ? (
          conversations.map((conversation) => (
            <ConversationListCard
              key={conversation?.id}
              conversation={conversation}
              selected={false}
              onClick={() => {
                alert('will write code to show conversations');
              }}
            />
          ))
        ) : (
          <Box
            borderRadius="8px"
            sx={{
              backgroundColor: palette.background.default,
            }}
          >
            <Typography variant="body1" textAlign="center" mt={4} mb={4}>
              No new messages
            </Typography>
          </Box>
        )}
      </Box>

      {conversations.length > 0 && (
        <Button fullWidth kind="secondary" endIcon={<ArrowForwardIcon />}>
          View all messages
        </Button>
      )}
    </Card>
  );
};

export default MessagesWidget;
